import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import All from '@/views/All'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/en',
      name: 'english',
      component: Home
    },
    {
      path: '/all',
      name: 'all',
      component: All
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
